// Shared enums mirroring the AppSync GraphQL schema (see design.md → GraphQL
// Schema). These are the single source of truth for enum values consumed by
// resolvers, Lambdas, and the frontend.
//
// Each enum is expressed as a `const` object plus a union type of its values so
// callers get both runtime constants and compile-time type safety without the
// downsides of TypeScript's `enum` (which does not erase cleanly under
// `isolatedModules`/`verbatimModuleSyntax`).
/** A member's role within a project. GraphQL: `enum ProjectRole`. */
export const ProjectRole = {
    owner: 'owner',
    editor: 'editor',
    viewer: 'viewer',
};
/** Lifecycle status of a course. GraphQL: `enum CourseStatus`. */
export const CourseStatus = {
    draft: 'draft',
    proposed: 'proposed',
    approved: 'approved',
    generating: 'generating',
    ready: 'ready',
};
/** Per-episode media generation status. GraphQL: `enum EpisodeGenerationStatus`. */
export const EpisodeGenerationStatus = {
    none: 'none',
    pending: 'pending',
    running: 'running',
    ready: 'ready',
    failed: 'failed',
};
/** Status of an async generation request. GraphQL: `enum GenerationStatus`. */
export const GenerationStatus = {
    PENDING: 'PENDING',
    RUNNING: 'RUNNING',
    READY: 'READY',
    FAILED: 'FAILED',
};
/** The kind of work a generation request performs. GraphQL: `enum GenerationKind`. */
export const GenerationKind = {
    AGENT_COURSE: 'AGENT_COURSE',
    EPISODE_AUDIO: 'EPISODE_AUDIO',
    EPISODE_VIDEO: 'EPISODE_VIDEO',
};
//# sourceMappingURL=enums.js.map